import { render } from "./AdminCreateSession.vue?vue&type=template&id=1cb5fd06&scoped=true"
import script from "./AdminCreateSession.vue?vue&type=script&lang=js"
export * from "./AdminCreateSession.vue?vue&type=script&lang=js"

import "./AdminCreateSession.vue?vue&type=style&index=0&id=1cb5fd06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb5fd06"]])

export default __exports__